<script lang="ts">
	import { classes } from '@thearc-hq/ui-kit/utils';
	import Button from './Button.svelte';
	import { getTranslate } from '@tolgee/svelte';
	import { goto } from '$app/navigation';

	export let additionalClass: string = '';
	export let orderNumber: number;

	const { t } = getTranslate();
</script>

<Button
	class={classes(
		additionalClass,
		'px-4 -mr-4 py-2 !rounded hover:underline text-accent-primary uppercase text-h-12'
	)}
	on:click={() => {
		goto(`/customer/orders/${orderNumber}`);
	}}
	text={$t('orders.showDetails')}
	iconPosition="right"
>
	<div class="i-sprenger-eye w-6 h-6 text-accent-primary -ml-1 -mr-1" slot="icon" />
</Button>
